import React from 'react'
import { AiOutlineCloseCircle, AiOutlineUserDelete } from 'react-icons/ai'
import { BsTrash2 } from 'react-icons/bs'

const DeleteProcessorModal = ({
  setShowDeleteModal,
  onDelete,
  loading,
  label = "processor"
}) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[99999] backdrop-blur-md">
      <div className="bg-white dark:bg-dark rounded-lg shadow-lg w-full max-w-[400px] p-4 relative">
        <button
          onClick={() => setShowDeleteModal(false)}
          className="absolute top-4 right-4 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
        >
          <AiOutlineCloseCircle className="h-7 w-7 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300" />
        </button>

        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-yellowcolor/10 rounded-full flex items-center justify-center mb-3">
            <div className="w-12 h-12 bg-yellowcolor/30 dark:bg-[#FEECB8] rounded-full flex items-center justify-center">
              <AiOutlineUserDelete className="h-8 w-8 text-yellowcolor" />
            </div>
          </div>

          <h2 className="text-xl font-bold mb-2 dark:text-white">
            Delete {label}
          </h2>
          <p className="text-gray-600 text-sm dark:text-gray-400 mb-6">
            Are you sure you want to delete this {label}? This action is irreversible.
          </p>

          <div className="flex gap-4 w-full">
            <button className="flex-1 h-12 text-sm rounded-full border border-gray-400 dark:border-border-darkGray dark:text-white" onClick={() => setShowDeleteModal(false)}>
              Cancel
            </button>
            <button className="flex-1 h-12 text-sm rounded-full bg-yellowcolor hover:bg-yellowcolor/80 text-black" onClick={onDelete}>
              {loading ? "Please wait..." : `Delete ${label}`}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeleteProcessorModal